import { LuminateRuntimeException } from './LuminateRuntimeException';
export class UnAuthorizedException extends LuminateRuntimeException {
    static UN_AUTHORIZED_STATUS_CODE = 403;
    constructor(message, cause, stack) {
        super(message, cause, stack, 'UnAuthorizedException', UnAuthorizedException.UN_AUTHORIZED_STATUS_CODE);
    }
}
